import { render } from "./demandSelectForm.vue?vue&type=template&id=7be80dfd&scoped=true"
import script from "./demandSelectForm.vue?vue&type=script&lang=js"
export * from "./demandSelectForm.vue?vue&type=script&lang=js"

import "./demandSelectForm.vue?vue&type=style&index=0&id=7be80dfd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7be80dfd"

export default script